import './ConversationModalSentMessages.css';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';

// The closed vocabularies the route returns. Anything outside them is shown as it arrived.
const STATE_LABELS = {
    read: 'Read',
    delivered: 'Delivered',
    failed: 'Failed',
    sent: 'Sent',
    not_attempted: 'Not attempted',
};

// A receipt, once one has arrived, supersedes what became of the send call itself.
const getState = (sentMessage) => sentMessage.receipt_status || sentMessage.status;

const getReceipts = (sentMessage) => [
    { name: 'Delivered', date: sentMessage.delivered_at },
    { name: 'Read', date: sentMessage.read_at },
    { name: 'Failed', date: sentMessage.failed_at },
].filter(receipt => receipt.date);

const ConversationModalSentMessages = ({ sentMessages }) => {
    return (
        <div className='conversation_sent_messages_container'>
            {sentMessages.map((sentMessage, index) => {
                const state = getState(sentMessage);
                // The internal code only answers for a send that never reached a provider.
                const failureLabel = sentMessage.receipt_label || sentMessage.failure_code;

                return (
                    <div className='conversation_sent_message' key={sentMessage.message_id}>
                        <div className='conversation_sent_message_header'>
                            <span className='conversation_sent_message_rank'>#{index + 1}</span>
                            <span className='conversation_sent_message_date'>
                                {sentMessage.created_at ? formatDateWithoutSeconds(sentMessage.created_at) : ''}
                            </span>
                            <span className={`conversation_sent_message_state conversation_sent_message_state_${state}`}>
                                {STATE_LABELS[state] || state}
                            </span>
                        </div>
                        <div className='conversation_sent_message_nature'>{sentMessage.nature}</div>
                        {getReceipts(sentMessage).map(receipt =>
                            <div className='conversation_sent_message_receipt' key={receipt.name}>
                                <span className='conversation_sent_message_receipt_name'>{receipt.name}</span>
                                <span>{formatDateWithoutSeconds(receipt.date)}</span>
                            </div>
                        )}
                        {(state == 'failed' || state == 'not_attempted') && failureLabel &&
                            <div className='conversation_sent_message_failure'>{failureLabel}</div>
                        }
                    </div>
                );
            })}
        </div>
    );
};

export default ConversationModalSentMessages;
